import RestrictedAccess from './RestrictedAccess'

const EditorAccess = ({ children }) => {
    return (
        <RestrictedAccess
            allowedRoles={['Admin', 'Editor',]}
        >
            {children}
        </RestrictedAccess>
    )
}

export default EditorAccess